import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import saveIcon from "../../../icons/common/save.png";
import closeIcon from "../../../icons/common/close.png";
import activeIcon from "../../../icons/common/active.png";
import inactiveIcon from "../../../icons/common/inactive.png";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLlAdminEndPoint, updateLlAdminEndPoint } from "../utils";
import axios from "axios";
import { setRowData } from "../../grid/gridReducer";
import notify from "../../../services/toasterService";
import { RootState } from "../../../redux/store";
import { setCurrencyData } from "../lladminreducer";

const PreviewCurrency = () => {
  const dispatch = useDispatch();
  const [currencyInfo, setCurrencyInfo] = useState<any[]>([]);

  /* Get selected data from Grid Reducer */
  const selRowData = useSelector(
    (state: RootState) => state.gridReducer.selectedRowData
  );
  // //console.log(selectedRowData, 'selectedRowData');

  useEffect(() => {
    if (selRowData && selRowData?.length > 0) {
      setCurrencyInfo(selRowData);
    }
    // Write for onload
  }, [selRowData]);

  const currencyFieldFocusOut = (value: any, key: any) => {
    setCurrencyInfo([{ ...currencyInfo[0], [key]: value }]);
  };

  /**
   * Changing status for Preview selected tabs
   * @param flag - true/false
   */
  const changeStatusForRowData = (flag: any) => {
    if (flag === false) {
      setCurrencyInfo([{ ...currencyInfo[0], activeForGrid: "Inactive" }]);
    } else {
      setCurrencyInfo([{ ...currencyInfo[0], activeForGrid: "Active" }]);
    }
  };

  const clearPreview = () => {
    dispatch(setRowData([]));
  };

  /**
   * PUT web service methods for Location setting tabs
   * @param data - Tab Name
   */
  const updateLocationSettingTabApi = async (data: any) => {
    //console.log(data);
    const endPointURL = updateLlAdminEndPoint(data.tabApiName, data.id);
    let body = {
      alternateCurrencyCode: data.alternateCurrency,
      currency: data.currency,
      currencyValidity: data.currencyValidity,
      deleted: data.deleted,
      id: data.id,
      isoCode: data.isoCode,
      organizationId: data.organizationId,
      tenantId: data.tenantId,
      primaryCurrencyCode: data.currencyCode,
    };
    const status = data.activeForGrid.toLowerCase();
    if (status === "active") {
      Object.assign(body, { active: true });
    } else {
      Object.assign(body, { active: false });
    }
    await axios
      .put(endPointURL, body)
      .then((res) => {
        notify("Currency code updated successfully", "success");
        getlAdminTabs(data.tabApiName);
      })
      .catch((err) => {
        notify("Failed to update currency code", "error");
      });
  };

  const getlAdminTabs = async (tabName: any) => {
    const endPointURL = getLlAdminEndPoint(tabName);
    await axios
      .get(endPointURL)
      .then((res: any) => {
        dispatch(setCurrencyData(res.data));
        const dataa = res.data[0];
        setCurrencyInfo(dataa);
        setTimeout(() => {
          dispatch(setRowData(currencyInfo));
        }, 5);
      })
      .catch((err) => {
        notify("Failed to update currency code", "error");
      });
  };

  const footerPreview = (data: any) => {
    return (
      <div className="col-sm-12 px-0 pt-5 ">
        <div className="col-sm-6 col-md-6 col-lg-6 pl-1.5rem pr-1 preview-Key  ">
          <ButtonComponent
            cssClass="e-outline opt-btn-light float-left"
            onClick={() => updateLocationSettingTabApi(data)}
          >
            <img src={saveIcon} alt="Save" />
          </ButtonComponent>

          <ButtonComponent
            cssClass="e-outline opt-btn-light float-left ml-3"
            onClick={() => clearPreview()}
          >
            <img src={closeIcon} alt="Close" />
          </ButtonComponent>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 preview-value pt-3">
          <p className="preview-status">
            {data?.activeForGrid === "Active" ||
            data?.activeForGrid === "active" ? (
              <span>
                <img
                  src={activeIcon}
                  alt="Status"
                  onClick={() => changeStatusForRowData(false)}
                />
                &nbsp; &nbsp; Active
              </span>
            ) : (
              <span>
                <img
                  src={inactiveIcon}
                  alt="Status"
                  onClick={() => changeStatusForRowData(true)}
                />
                &nbsp; &nbsp; Inactive
              </span>
            )}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div>
      {currencyInfo && currencyInfo?.length > 0 ? (
        <div className="col-sm-12 px-3 py-3 preview-details  ">
          <div className="col-sm-12 px-0 pt-4 ">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  " style={{lineHeight: '18px'}}>ID</div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
              {currencyInfo[0].id}
            </div>
          </div>
          <div className="col-sm-12 px-0 pt-4">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  " style={{lineHeight: '33px'}}>
              Currency
            </div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
              {/* <InlineInputEdit inputClassName="txtEditClassNameInput"
                                text={currencyInfo[0].currency}
                                labelClassName="txtEditClassName"
                                onFocusOut={(e) => currencyFieldFocusOut(e, 'currency')}
                                labelPlaceHolder='---'
                            /> */}
              <input
                type="text"
                className="form-control border-none pl-0 cursor-pointer txtEditFieldFocus boxShadow-None"
                value={currencyInfo[0]?.currency}
                onChange={(e: any) =>
                  currencyFieldFocusOut(e.target.value, "currency")
                }
              />
            </div>
          </div>
          <div className="col-sm-12 px-0 pt-4">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  " style={{lineHeight: '33px'}}>
              ISO Code
            </div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
              {/* <InlineInputEdit inputClassName="txtEditClassNameInput"
                                text={currencyInfo[0].isoCode}
                                labelClassName="txtEditClassName"
                                onFocusOut={(e) => currencyFieldFocusOut(e, 'isoCode')}
                                labelPlaceHolder='---'
                            /> */}
              <input
                type="text"
                className="form-control border-none pl-0 cursor-pointer txtEditFieldFocus boxShadow-None"
                value={currencyInfo[0]?.isoCode}
                onChange={(e: any) =>
                  currencyFieldFocusOut(e.target.value, "isoCode")
                }
              />
            </div>
          </div>
          <div className="col-sm-12 px-0 pt-4">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  " style={{top: '5px'}}>
              Currency Code
            </div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
              {/* <InlineInputEdit inputClassName="txtEditClassNameInput"
                                text={currencyInfo[0].currencyCode}
                                labelClassName="txtEditClassName"
                                onFocusOut={(e) => currencyFieldFocusOut(e, 'currencyCode')}
                                labelPlaceHolder='---'
                            /> */}
              <input
                type="text"
                className="form-control border-none pl-0 cursor-pointer txtEditFieldFocus boxShadow-None"
                value={currencyInfo[0]?.currencyCode}
                onChange={(e: any) =>
                  currencyFieldFocusOut(e.target.value, "currencyCode")
                }
              />
            </div>
          </div>

          <div className="col-sm-12 px-0 pt-5 pb-4">
            {footerPreview(currencyInfo[0])}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default PreviewCurrency;
